import { useCallback } from "react";
import { Mail } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { getNextQueryParams } from "components/helpers";
import useAuthorized from "hooks/useAuthorized";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import { TableCreateButton } from "components/BaseTableV3/TableCreateButton";
import EmailTemplateService from "services/EmailTemplate";
import {
  invalidateEmailTemplateTableQuery,
  useEmailTemplateTable,
} from "hooks/useEmailTemplateTable";

export const EMAIL_TEMPLATE_TABLE_CONSTANTS = {
  tableName: "email_templates",
  queryKey: "email_template",
  className: "EmailTemplate",
  header: "Email Templates",
  headerIcon: Mail,
};

const CREATE_ACLS = [
  ACL_RELATIONSHIPS.emailTemplatesTags.read,
  ACL_RELATIONSHIPS.emailTemplates.create,
];

const EmailTemplateTableV3 = () => {
  const enableTags = useAuthorized(
    [
      ACL_RELATIONSHIPS.emailTemplatesTags.create,
      ACL_RELATIONSHIPS.emailTemplatesTags.read,
      ACL_RELATIONSHIPS.emailTemplatesTags.delete,
    ],
    { partialMatch: true }
  );
  const { filters, columns, customFields } = useEmailTemplateTable({
    className: EMAIL_TEMPLATE_TABLE_CONSTANTS.className,
    tableName: EMAIL_TEMPLATE_TABLE_CONSTANTS.tableName,
  });

  const fetchData = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response =
          await EmailTemplateService.getEmailTemplatesTable(nextQueryParams);

        return response;
      } catch (error) {
        console.error("Error fetching email templates:", error);
        throw error;
      }
    },
    [columns]
  );

  const createButton = (
    <TableCreateButton
      permissions={CREATE_ACLS}
      to="/settings/email_templates/new"
    >
      New Email Template
    </TableCreateButton>
  );

  return (
    <BaseTableV3
      columns={columns}
      filters={filters}
      customFields={customFields ?? []}
      tagsDropdownParams={{ visible: enableTags }}
      queryKey={EMAIL_TEMPLATE_TABLE_CONSTANTS.queryKey}
      className={EMAIL_TEMPLATE_TABLE_CONSTANTS.className}
      tableName={EMAIL_TEMPLATE_TABLE_CONSTANTS.tableName}
      headerIcon={EMAIL_TEMPLATE_TABLE_CONSTANTS.headerIcon}
      header={EMAIL_TEMPLATE_TABLE_CONSTANTS.header}
      enableSearch
      enableSettings
      fetchData={fetchData}
      createButton={createButton}
      invalidateData={invalidateEmailTemplateTableQuery}
    />
  );
};

export default EmailTemplateTableV3;
